import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { Cell } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { PersonContext } from '../PersonContext'
import { UserLink } from '../../app/Links'
import DataView from '../../common/DataView'
import { getEntity } from '../../../util/EntityUtil'

const smallLink = css`
  margin-inline-start: 5px !important;
  margin-bottom: 2px !important;
  font-size: smaller;
  line-height: 18px;
`
const cssWrap = css`
  overflow-wrap: break-word;
`

const toClickOrNotToClick = (contributorId, contributorName) => {
  const contributorEntity = getEntity(contributorId)
  if (contributorEntity.numericId <= 30) {
    return (
      <span css={(cssWrap, smallLink)}>
        {contributorEntity.alphaNumericId} ({contributorName})
      </span>
    )
  }
  return <UserLink userId={contributorId} userName={contributorName} css={smallLink} showId />
}
export default function PSAttribution({ additionalDataItems, attribution, cellColumns }) {
  const userNames = useContext(PersonContext).currentPerson.contactNames
  const { t } = useTranslation()

  if (!attribution) {
    return null
  }

  const getNameOrDefaultToId = (id) => (id && userNames[id] ? userNames[id] : id)
  const contributorId = attribution.contributor ? attribution.contributor.id : null
  const contributorName = getNameOrDefaultToId(contributorId)
  const submitterId = attribution.submitter ? attribution.submitter.id : null
  const submitterName = getNameOrDefaultToId(submitterId)
  const modified =
    attribution && attribution?.modifiedDateNormalized && attribution?.modifiedDateNormalized[0]
      ? attribution?.modifiedDateNormalized[0].value
      : ''
  const changeMessage = attribution.changeMessage ? attribution.changeMessage : null

  const psAttributionData = [
    {
      label: t('contributor', 'Contributor'),
      detail: toClickOrNotToClick(contributorId, contributorName),
    },
    {
      label: t('submitter', 'Submitter'),
      detail: toClickOrNotToClick(submitterId, submitterName),
    },
    {
      label: t('modified.label', 'Modified'),
      detail: modified,
    },
  ]
  if (changeMessage !== null)
    psAttributionData.push({
      label: t('changeMessage', 'Change Message'),
      detail: changeMessage,
    })

  if (additionalDataItems) {
    additionalDataItems.forEach((additionalDataItem) => {
      psAttributionData.push(additionalDataItem)
    })
  }
  return (
    <Cell columns={cellColumns}>
      <DataView data={psAttributionData} />
    </Cell>
  )
}

PSAttribution.propTypes = {
  attribution: PropTypes.shape({
    contributor: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
}
